import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';

export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const configStore = useConfigStore();

  if (from.name === undefined) {
    configStore.setTransitionName('fade-navigation');
    return next();
  }

  // No tabIndex route -> appear
  if (to.meta.tabIndex === undefined || from.meta.tabIndex === undefined) {
    if (to.name === 'login') {
      configStore.setTransitionName('disappear-no-tabs');
    } else {
      configStore.setTransitionName('appear');
    }

    return next();
  }

  // To avoid transition when navigating on the same tab
  const onSameTabNavigation = to.meta.tabIndex === from.meta.tabIndex;

  if (onSameTabNavigation) {
    configStore.setTransitionName('fade-navigation');
    return next();
  }

  const toIndex = to.meta.tabIndex as number;
  const fromIndex = from.meta.tabIndex as number;

  // If tab to the right -> appear, if tab to the left -> disappear
  const transitionName = toIndex < fromIndex ? 'disappear' : 'appear';
  configStore.setTransitionName(transitionName);

  next();
};
